import { LOGO_URL, CONTACT, NAV_LINKS } from "@/data/content";
import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight, Cookie } from "lucide-react";
import { FooterCompanyInfo, FooterAnpc } from "./FooterLegal";

const LEGAL_LINKS = [
  { label: "Politica de confidențialitate", to: "/politica-confidentialitate" },
  { label: "Politica de cookies", to: "/politica-cookies" },
  { label: "Termeni și condiții", to: "/termeni-conditii" },
];

const Footer = () => {
  const year = new Date().getFullYear();
  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent("c2-open-cookie-settings"));
  };
  return (
    <footer data-testid="footer" className="relative bg-white border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <img src={LOGO_URL} alt="C2 Advertising" className="h-14 lg:h-16 w-auto" />
            <p className="mt-5 text-slate-600 max-w-md leading-relaxed">
              Agenție de performance marketing din România.
              Construim Google Ads și Social Media Marketing pentru branduri serioase.
            </p>
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="footer-email"
              className="mt-6 inline-flex items-center gap-2 text-slate-900 font-semibold hover:text-magenta transition-colors"
            >
              <Mail size={18} />
              {CONTACT.email}
              <ArrowUpRight size={16} />
            </a>
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              data-testid="footer-phone"
              className="mt-3 flex items-center gap-2 text-slate-700 font-semibold hover:text-magenta transition-colors"
            >
              <Phone size={18} />
              {CONTACT.phone}
            </a>
            <FooterCompanyInfo />
            <FooterAnpc />
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-display text-sm font-bold text-slate-900 uppercase tracking-wider">
              Navigare
            </h4>
            <ul className="mt-4 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-slate-600 hover:text-magenta transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-display text-sm font-bold text-slate-900 uppercase tracking-wider">
              Servicii
            </h4>
            <ul className="mt-4 space-y-3 text-slate-600">
              <li>Google Ads & PPC</li>
              <li>Social Media Marketing</li>
              <li>Audit & Strategie</li>
              <li>Setup tracking GA4</li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-sm font-bold text-slate-900 uppercase tracking-wider">
              Legal
            </h4>
            <ul className="mt-4 space-y-3">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-legal-${l.to.replace("/", "")}`}
                    className="text-slate-600 hover:text-magenta transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  onClick={openCookieSettings}
                  data-testid="footer-cookie-settings"
                  className="inline-flex items-center gap-2 text-slate-600 hover:text-magenta transition-colors"
                >
                  <Cookie size={14} />
                  Setări cookies
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="font-display text-7xl sm:text-8xl lg:text-9xl font-extrabold tracking-tighter leading-none select-none">
            <span className="text-magenta">C2</span>
            <span className="text-electric">.</span>
          </div>
          <div className="text-sm text-slate-500">
            © {year} C2 Advertising · Toate drepturile rezervate ·{" "}
            <a
              href={`https://${CONTACT.domain}`}
              className="font-semibold text-slate-700 hover:text-magenta"
            >
              {CONTACT.domain}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
